import { canUseDOM } from '@ps/web-core-utils';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { DatePicker } from '@swf/sports/components';

import { TXTWCL_FromX_N0, TXTWCL_ToX_N0 } from './DateFilters.messages.json';
import styles from './DateFilters.scss';

interface Props {
  fromDate?: Date;
  toDate?: Date;
  selectFromDate: (fromDate: Date) => void;
  selectToDate: (toDate: Date) => void;
  minDate: Date;
  maxDate: Date;
}

const DateFilters: React.FC<Props> = ({
  fromDate,
  toDate,
  selectFromDate,
  selectToDate,
  minDate,
  maxDate
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.dateFiltersWrapper}>
      {canUseDOM && (
        <DatePicker
          onChange={(dates) => selectFromDate(dates[0])}
          formatDate={(formattedDate) => formatMessage(TXTWCL_FromX_N0, { 0: formattedDate })}
          value={fromDate}
          altFormat="d M Y"
          disableMobile
          minDate={minDate}
          maxDate={toDate}
        />
      )}
      {canUseDOM && (
        <DatePicker
          onChange={(dates) => selectToDate(dates[0])}
          formatDate={(formattedDate) => formatMessage(TXTWCL_ToX_N0, { 0: formattedDate })}
          value={toDate}
          altFormat="d M Y"
          disableMobile
          minDate={fromDate}
          maxDate={maxDate}
          calendarPosition="right"
        />
      )}
    </div>
  );
};

export default DateFilters;
